import axiosPrivate from "../axiosPrivate"

export const createFacebookAdCreative = async (adAccountId, data) => {
  return await axiosPrivate.post(`act_${adAccountId}/adcreatives`, data)
}
